import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Bike, Loader2, AlertCircle } from "lucide-react";
import axios from "axios";
import { API_URL } from "@/utils/apiConfig";
import LangToggle from "./LangToggle";

const API = API_URL;

export default function EstafetaLogin({ onLogin, lang, setLang, t }) {
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!token.trim()) return;
    setLoading(true);
    setError("");
    try {
      const res = await axios.post(
        `${API}/api/v1/deliverers/auth/token?token=${encodeURIComponent(token.trim())}`
      );
      localStorage.setItem("estafeta_token", token.trim());
      const payload = res.data?.data || res.data;
      onLogin(payload.deliverer, token.trim());
    } catch (err) {
      setError(
        err.response?.status === 403 ? t("disabledAccount") : t("invalidToken")
      );
    }
    setLoading(false);
  };

  return (
    <div
      className="min-h-screen bg-gradient-to-b from-emerald-600 to-emerald-800 flex flex-col items-center justify-center px-6"
      data-testid="estafeta-login"
    >
      <div className="absolute top-4 right-4">
        <LangToggle lang={lang} setLang={setLang} />
      </div>
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-20 h-20 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-4 backdrop-blur-sm">
            <Bike className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-white tracking-tight">
            {t("appTitle")}
          </h1>
          <p className="text-emerald-200 text-sm mt-1">{t("loginSubtitle")}</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          <Input
            value={token}
            onChange={(e) => setToken(e.target.value)}
            placeholder={t("tokenPlaceholder")}
            className="h-12 bg-white/15 border-white/30 text-white placeholder:text-emerald-200 text-center font-mono text-sm backdrop-blur-sm"
            data-testid="estafeta-token-input"
          />
          {error && (
            <div className="flex items-center gap-2 text-red-200 text-sm justify-center">
              <AlertCircle className="w-4 h-4" />
              {error}
            </div>
          )}
          <Button
            type="submit"
            disabled={loading || !token.trim()}
            className="w-full h-12 bg-white text-emerald-700 font-bold text-base hover:bg-emerald-50"
            data-testid="estafeta-login-btn"
          >
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : t("enter")}
          </Button>
        </form>

        <p className="text-emerald-300 text-xs text-center mt-6">
          {t("askAdmin")}
        </p>

        <div className="mt-6 p-4 bg-white/10 rounded-xl backdrop-blur-sm">
          <p className="text-white text-sm font-medium text-center mb-2">📲 Instalar App</p>
          <p className="text-emerald-200 text-xs text-center"><strong>Android:</strong> Menu (⋮) → "Añadir a pantalla de inicio"</p>
          <p className="text-emerald-200 text-xs text-center mt-1"><strong>iPhone:</strong> Compartir (↑) → "Añadir a pantalla de inicio"</p>
        </div>
      </div>
    </div>
  );
}
